module.exports = __webpack_public_path__ + "static/media/bags-shopping.5d5fa2dd.svg";